import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './view/header/header.component';
import { HomeComponent } from './view/home/home.component';
import { FooterComponent } from './view/footer/footer.component';
import { ShowcaseComponent } from './view/home/showcase/showcase.component';
import { SharedModule } from './modules/shared/shared.module';
import { BulletinComponent } from './view/home/bulletin/bulletin.component';
import { ParentComponent } from './view/home/parent/parent.component';
import { WhyComponent } from './view/home/why/why.component';
import { LifeComponent } from './view/home/life/life.component';
import { CheckOutComponent } from './view/home/check-out/check-out.component';
import { AboutModule } from './modules/about/about.module';
import { AngularFireModule } from 'angularfire2';
import { environment } from 'src/environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { ActivitiesComponent } from './view/home/activities/activities.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GalleryModule } from './modules/gallery/gallery.module';
import { AchieversModule } from './modules/achievers/achievers.module';
import { CalendarModule } from './modules/calendar/calendar.module';
import { RulesModule } from './modules/rules/rules.module';
import { InfraModule } from './modules/infra/infra.module';
import { AdmissionModule } from './modules/admission/admission.module';
import { CareerComponent } from './view/career/career.component';
import { ContactUsComponent } from './view/contact-us/contact-us.component';
import { KindergartenComponent } from './view/kindergarten/kindergarten.component';
import { LifeModule } from './modules/life/life.module';
import { CbseDisclosureComponent } from './view/cbse-disclosure/cbse-disclosure.component';
import { TransferCertificateComponent } from './view/transfer-certificate/transfer-certificate.component';
import { VideoModule } from './modules/video/video.module';
import { MediaModule } from './modules/media/media.module';
import { TestimonialModule } from './modules/testimonial/testimonial.module';
import { FaqComponent } from './view/faq/faq.component';
import { FormsModule } from '@angular/forms';
import { BlogsModule } from './modules/blogs/blogs.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    ShowcaseComponent,
    BulletinComponent,
    ParentComponent,
    WhyComponent,
    LifeComponent,
    CheckOutComponent,
    ActivitiesComponent,
    CareerComponent,
    ContactUsComponent,
    KindergartenComponent,
    CbseDisclosureComponent,
    TransferCertificateComponent,
    FaqComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    AboutModule,
    RulesModule,
    CalendarModule,
    AchieversModule,
    AdmissionModule,
    InfraModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    CarouselModule,
    BrowserAnimationsModule,
    LifeModule,
    GalleryModule,
    VideoModule,
    MediaModule,
    TestimonialModule,
    FormsModule,
    BlogsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
